"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = require("react");
const React = require("react");
require("./card.less");
class Card extends react_1.Component {
    render() {
        const { children, className = "", title } = this.props;
        return (React.createElement("div", { className: `card ${className}` },
            title && React.createElement("div", { className: "card__title" }, title),
            React.createElement("div", { className: "card__children" }, children)));
    }
}
exports.Card = Card;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/card/card.tsx
// module id = 2699
// module chunks = 0 1